import s from"../packages/ads-sdk/package.json.js";const o=s.version;export{o as version};
